module.exports = __webpack_public_path__ + "static/media/drugs-medicine-pills-svgrepo-com.438f187b.svg";